import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { TrendingUp, Cpu, Wrench, Layers } from "lucide-react";
import {
  NA_PRIMARY,
  NA_SECONDARY,
  naReadableText,
  naGradientLine,
  naDarkCardBase,
  naCardBgHover,
  onDarkCardEnter,
  onDarkCardLeave,
} from "./naSectionTokens";

const STATS = [
  {
    icon: TrendingUp,
    headline: "$150+ billion",
    sub: "Global digital twin market scale expected by 2030.",
    color: NA_PRIMARY,
  },
  {
    icon: Cpu,
    headline: "70%+",
    sub: "Of smart city initiatives expected to integrate digital twin technologies within the next decade.",
    color: NA_SECONDARY,
  },
  {
    icon: Layers,
    headline: "AI + real-time data",
    sub: "Infrastructure owners are increasingly investing to improve efficiency and asset performance.",
    color: NA_PRIMARY,
  },
  {
    icon: Wrench,
    headline: "Operating costs",
    sub: "Digital twins can help reduce infrastructure spend through predictive maintenance and optimized asset management.",
    color: NA_SECONDARY,
  },
];

function NAStatisticsSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center mb-5">
          <Col className="text-center">
            <h2
              className="mb-0"
              style={{
                fontSize: size ? "2.25rem" : "1.7rem",
                fontWeight: 700,
                letterSpacing: "0.05em",
                lineHeight: 1.2,
                textTransform: "uppercase",
                color: NA_PRIMARY,
                ...naReadableText,
              }}
            >
              Statistics &amp; industry insights
            </h2>
            <div
              style={{
                width: "110px",
                height: "4px",
                borderRadius: "2px",
                margin: "1rem auto 0",
                ...naGradientLine,
              }}
            />
          </Col>
        </Row>
        <Row>
          {STATS.map((item, index) => {
            const Icon = item.icon;
            const isPrimary = item.color === NA_PRIMARY;
            return (
              <Col key={index} lg={6} className="mb-4">
                <Card
                  style={{
                    ...naDarkCardBase,
                    borderRadius: "20px",
                    padding: size ? "1.75rem" : "1.4rem",
                    height: "100%",
                    transition: "all 0.35s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => onDarkCardEnter(e, item.color)}
                  onMouseLeave={onDarkCardLeave}
                >
                  <div className="d-flex align-items-start">
                    <div
                      style={{
                        width: size ? 56 : 50,
                        height: size ? 56 : 50,
                        minWidth: size ? 56 : 50,
                        borderRadius: "16px",
                        background: `linear-gradient(145deg, ${item.color}30, ${item.color}12)`,
                        border: `2px solid ${item.color}55`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "1.1rem",
                      }}
                    >
                      <Icon size={size ? 28 : 24} strokeWidth={2} style={{ color: item.color }} />
                    </div>
                    <div>
                      <h3
                        className="text-white mb-2"
                        style={{
                          fontSize: size ? "1.45rem" : "1.2rem",
                          fontWeight: 800,
                          letterSpacing: "0.02em",
                          lineHeight: 1.25,
                          textTransform: "uppercase",
                          ...naReadableText,
                        }}
                      >
                        {item.headline}
                      </h3>
                      <p
                        className="text-white mb-0"
                        style={{
                          fontSize: size ? "1rem" : "0.92rem",
                          lineHeight: 1.65,
                          opacity: 0.95,
                          fontWeight: 400,
                          ...naReadableText,
                        }}
                      >
                        {item.sub}
                      </p>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
        <Row className="mt-2">
          <Col lg={12}>
            <Card
              style={{
                ...naDarkCardBase,
                border: `1px solid ${NA_SECONDARY}40`,
                borderRadius: "16px",
                padding: size ? "1.5rem" : "1.25rem",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = naCardBgHover;
              }}
              onMouseLeave={onDarkCardLeave}
            >
              <p
                className="mb-0 text-center"
                style={{
                  fontSize: size ? "1.08rem" : "1rem",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: NA_SECONDARY,
                  ...naReadableText,
                }}
              >
                BIM, GIS &amp; IoT integration is becoming a core strategy for next-generation
                infrastructure delivery.
              </p>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NAStatisticsSection;
